<template>
  <div>
    <vs-button color="primary" size="small" v-if="file != 'null' && file != '-' && file" :href="link">Download</vs-button>
    <vs-button color="primary" type="border" size="small" v-else @click="() => params.openPopupUpload(this.params.data)">Upload</vs-button>
  </div>
</template>

<script>
export default {
  name: "CellRendererFile",
  computed: {
    file () {
      return this.params.data.file;
    },
    link () {
      console.log(this.params.data.file);
      return this.params.storage().purchase + this.params.data.file;
    }
  }
}
</script>

<style scoped>

</style>
